import './SelectedElements.scss';

import { defineComponent, h, PropType } from 'vue';
import { Background } from '../Colours';

import FloatingText from './FloatingText';

export default defineComponent({
    props: {
        vertices: { required: true, type: Number },
        edges: { required: true, type: Number },
        faces: { required: true, type: Number },
        background: { required: true, type: String as PropType<Background> },
    },

    render() {
        return h('div', {
            id: 'selected-elements',
            class: this.background === Background.white ? 'light' : '',
        }, [
            h(FloatingText, undefined, { default: () => [
                h('span', { class: 'vertices' }, [this.vertices.toString()]),
                h('span', { class: 'edges' }, [this.edges.toString()]),
                h('span', { class: 'faces' }, [this.faces.toString()]),
            ]}),
        ]);
    }
});
